module.exports = __webpack_public_path__ + "static/media/card-logo-2.33d21eee.svg";